<template>
  <component
    :href="href"
    :is="is"
    :type="type"
    class="c-header-icon-button"
    @click="onClicked"
    @mouseenter="$emit('icon-button-mouseenter')"
  >
    <i :class="['c-header-icon-button__icon', `icon-${iconName}`]"></i>
    <div :class="['c-header-icon-button__text', size]" v-html="text"></div>
  </component>
</template>

<script>
export default {
  name: 'ComponentHeaderIconButton',
  props: {
    href: { type: String, default: null },
    iconName: { type: String, required: true, default: 'heart-filled' },
    size: { type: String, default: 'medium' },
    text: { type: String, default: '' },
    type: { type: String, default: null },
  },
  computed: {
    is() {
      return this.type === 'button' ? 'button' : 'a'
    },
  },
  methods: {
    onClicked($event) {
      if (this.type === 'button') {
        $event.preventDefault()
        this.$emit('icon-button-clicked')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-icon-button {
  text-align: center;
  display: block;
  width: 100%;

  transition: opacity 0.3s;

  &:hover {
    opacity: 0.6;
  }

  &__icon {
    font-size: 20px;
  }

  &__text {
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    margin-top: 4px;

    &.small {
      font-size: 8px;
      color: variables.$color-text-gray;
    }
  }
}
</style>
